import { Visibility } from "@mui/icons-material";
import { Box, IconButton, Tooltip } from "@mui/material";
import {
  convertDateWithValidation,
  dateFormatterWithTime,
} from "../helper/losDataHelper";

export const customerDocumentsColumn = [
  {
    field: "documentDetailsId",
    headerName: "Document Details Id",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "newgenId",
    headerName: "New Gen ID",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "fileName",
    headerName: "File Name",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "documentCategory",
    headerName: "Document Category",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "documentType",
    headerName: "Document Type",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
];

export const customerAddressColumn = [
  {
    field: "addressId",
    headerName: "Address ID",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "addressType",
    headerName: "Address Type",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "flatDoorBuildingBlock",
    headerName: "Flat/Door/Building/Block",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "roadStreet",
    headerName: "Road/Street",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "areaLocality",
    headerName: "Area/Locality",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "cityTown",
    headerName: "City/Town",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "state",
    headerName: "State",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "landmark",
    headerName: "Landmark",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "pincode",
    headerName: "Pincode",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "isResidentialSameAsPermanent",
    headerName: "Is Residential Same As Permanent",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
];

export const customerInfoListColumn = [
  {
    field: "internalCustomerId",
    headerName: "Internal Customer ID",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "internalApplicationId",
    headerName: "Internal Application ID",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "customerId",
    headerName: "Customer ID",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "firstName",
    headerName: "First Name",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "surName",
    headerName: "Sur Name",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
  },
  {
    field: "dateOfBirth",
    headerName: "DOB",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
    valueGetter: (params) => convertDateWithValidation(params.row.dateOfBirth),
  },
  {
    field: "createdDate",
    headerName: "Created Date",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
    valueGetter: (params) => dateFormatterWithTime(params.row.createdDate),
  },
  {
    field: "lastModifiedDate",
    headerName: "Last Modified Date",
    headerAlign: "center",
    align: "center",
    flex: 200,
    type: "string",
    editable: false,
    valueGetter: (params) => dateFormatterWithTime(params.row.lastModifiedDate),
  },
  {
    field: "icon",
    headerName: "",
    headerAlign: "center",
    align: "center",
    maxWidth: 50,
    type: "string",
    editable: false,
    renderCell: (params) => {
      return (
        <Box
          sx={{
            justifyContent: "center",
            display: "flex",
            flex: 25,
          }}
        >
          <Tooltip title="View Detail">
            <IconButton
              onClick={(e) => {
                viewCustomerDetail(params);
              }}
            >
              <Visibility sx={{ color: "black" }} />
            </IconButton>
          </Tooltip>
        </Box>
      );
    },
  },
];

const viewCustomerDetail = (param) => {
  window.open(`/stlap/home/losData/customerInfoList/${param.id}`, "_blank");
};

export const customerInfoListData = async (values) => {
  let dataList = [];
  values.forEach((v) => {
    dataList.push({
      customerId: v["customerId"],
      internalCustomerId: v["internalCustomerId"],
      internalApplicationId: v["internalApplicationId"],
      firstName: v["firstName"],
      surName: v["surName"],
      dateOfBirth: v["dateOfBirth"],
      createdDate: v["createdDate"],
      lastModifiedDate: v["lastModifiedDate"],
    });
  });
  return dataList;
};
